<template>
  <div class="app">
    <router-view />
    <ToasterCatcher />
    <DialogComponent
      v-model="termsDialogIsOpen"
      max-width="50rem"
      persistent
    >
      <template #default>
        <TermsPage />
      </template>
    </DialogComponent>
    <ForceUpdateGuard />
  </div>
</template>

<script>
import * as auth from '@acs/components-library/src/auth.js';
import ToasterCatcher from './components/app/ToasterCatcher.vue';
import TermsPage from './views/Terms.vue';
import DialogComponent from '@acs/components-library/src/components/common/Dialog.vue';
import ForceUpdateGuard from './components/app/ForceUpdateGuard.vue';
import { getLocale, isSupportedLocale, setLocalStorageLocale } from './i18n.js';
import { updateCustomHeaders } from '@acs/components-library/src/apollo.js';
import { useTermsStore } from '@acs/components-library/src/stores/termsStore';
import { storeToRefs } from 'pinia';

export default {
  components: {
    DialogComponent,
    ForceUpdateGuard,
    TermsPage,
    ToasterCatcher,
  },
  setup() {
    const termsStore = useTermsStore();
    const { isOpen: termsDialogIsOpen } = storeToRefs(termsStore);
    return { termsStore, termsDialogIsOpen };
  },
  async mounted() {
    auth.addIsUserLoggedInListener(this.handleUserLoggedState);

    if (auth.isUserLoggedIn()) {
      await auth.refreshToken();
      await this.handleUserLoggedState(true);
    }
  },
  beforeUnmount() {
    auth.removeIsUserLoggedInListener();
  },
  methods: {
    async updateLocale() {
      this.$i18n.locale = getLocale();
      const { lang } = await auth.getUser() || {};
      if (isSupportedLocale(lang)) {
        this.$i18n.locale = lang;
        updateCustomHeaders({ 'Accept-Language': lang });
        setLocalStorageLocale(lang);
      }
    },
    async handleUserLoggedState(isLoggedIn) {
      if (!isLoggedIn) {
        this.$router.replace({ name: 'Login' });
        return;
      }

      await Promise.allSettled([
        this.termsStore.popIfNotAccepted(),
        auth.fetchUser().then(() => this.updateLocale()),
      ]);
    },
  },
};
</script>

<style lang="scss">
.app {
  position: relative;
}
</style>
